<script setup lang="ts">
type Quote = NonNullable<CrystallizeProduct['components']['quote']>

const props = defineProps<{ data: Quote }>()

const hasContent = computed(() => props.data.text?.some(blockHasContent))
</script>

<template>
  <div v-if="hasContent" class="bg-blurple-500 py-5xl">
    <section class="mx-auto max-w-3xl w-[95vw] flex gap-xl items-center">
      <IconsQuotesAngles class="self-start shrink-0 fill-blurple-300" />
      <div class="flex flex-col gap-l text-white">
        <CrystallizeRichText v-for="(block, key) in data.text" :key="key" class="title-m font-semibold" :block="block" />
        <span v-if="data.author?.name" class="text-body">
          - {{ data.author.name }}{{ data.author.title && `, ${data.author.title}` }}
        </span>
      </div>
    </section>
  </div>
</template>
